import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { intl } from '@trello/i18n';
import { ArchiveIcon } from '@trello/nachos/icons/archive';
import type { QuickCardEditorTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { useArchiveCard } from 'app/src/components/CardFront/useArchiveCard';
import { ShortcutTooltip } from 'app/src/components/ShortcutTooltip';
import { QuickCardEditorButton } from './QuickCardEditorButton';
interface ArchiveCardButtonProps {
  isCardTemplate: boolean;
  isClosed: boolean;
  onClose: () => void;
}

export const ArchiveCardButton: FunctionComponent<ArchiveCardButtonProps> = ({
  isCardTemplate,
  isClosed,
  onClose,
}) => {
  const archiveCard = useArchiveCard({
    source: 'quickCardEditorInlineDialog',
    shouldShowFlag: false,
  });

  const onClick = useCallback(() => {
    archiveCard();
    onClose();
  }, [archiveCard, onClose]);

  if (isClosed) {
    return null;
  }

  return (
    <ShortcutTooltip
      shortcutText={intl.formatMessage({
        id: 'templates.quick_card_editor.archive-card',
        defaultMessage: 'Archive card',
        description: 'Tooltip text for archiving a card',
      })}
      shortcutKey="c"
      position="right"
    >
      <QuickCardEditorButton
        icon={<ArchiveIcon size="small" />}
        onClick={onClick}
        testId={getTestId<QuickCardEditorTestIds>('quick-card-editor-archive')}
      >
        {isCardTemplate ? (
          <FormattedMessage
            id="templates.quick_card_editor.hide-from-list"
            defaultMessage="Hide from list"
            description="Quick card editor Hide from list button"
          />
        ) : (
          <FormattedMessage
            id="templates.quick_card_editor.archive"
            defaultMessage="Archive"
            description="Quick card editor Archive button"
          />
        )}
      </QuickCardEditorButton>
    </ShortcutTooltip>
  );
};
